import React, { useEffect, useRef, useState } from 'react'
import { useSignUpMutation } from '../../services/authApi'
import { useGetTimezonesQuery } from '../../services/authApi'
import { Link, useNavigate } from 'react-router-dom'
import Input from './Input'
import loader from '../../assets/images/loader.gif'
import { OTP_TIMER } from '../../keys'
import OptionButton from '../../UI/OptionButton'
import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date'
import { Select } from 'antd'
import { ToastContainer, toast } from 'react-toastify'
const Left = () => {
    const [signup, { isLoading, isError, error }] = useSignUpMutation()
    const { data: timezoneData, isLoading: tzLoading } = useGetTimezonesQuery()
    // console.log(timezoneData)

    // console.log("ERR",error)

    const [message, setMessage] = useState('')
    const [email, setEmail] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [gender, setGender] = useState('Male')
    const [year, setYear] = useState('')
    const [month, setMonth] = useState('')
    const [day, setDay] = useState('')
    const [timezone, setTimezone] = useState('')

    const paddedMonth = String(+month + 1).padStart(2, '0')
    const paddedDay = String(day).padStart(2, '0')
    const dateOfBirth = `${year}-${paddedMonth}-${paddedDay}` 

    const navigate = useNavigate()
    const form = useRef(null)
  useEffect(() => {
    if (timezoneData?.data && timezoneData.data.length > 0) {
      //  device timezone"
      let deviceTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

      //  Common aliases mapping
      const tzAliases = {
        "Asia/Calcutta": "Asia/Kolkata",
        "Asia/Bombay": "Asia/Kolkata",
        "Europe/Belfast": "Europe/London",
        "Europe/Tel_Aviv": "Asia/Jerusalem",
        "Europe/Kyiv": "Europe/Kiev",
        "US/Eastern": "America/New_York",
        "US/Central": "America/Chicago",
        "US/Mountain": "America/Denver",
        "US/Pacific": "America/Los_Angeles",
        "US/Alaska": "America/Anchorage",
        "US/Hawaii": "Pacific/Honolulu",
        "Etc/UTC": "UTC",
        "Etc/GMT": "GMT",
        "Etc/GMT+0": "GMT",
        "Etc/GMT-0": "GMT",
      };

      if (deviceTz in tzAliases) {
        deviceTz = tzAliases[deviceTz];
      }

      // Match device timezone with API data
      const matchedTz = timezoneData.data.find((tz) => tz.name === deviceTz);

      //  Set timezone automatically
      if (matchedTz) {
        setTimezone(matchedTz.id);
        localStorage.setItem("device_timezone", deviceTz);
       
      } else {
        // console.warn("⚠️ No exact match found for timezone:", deviceTz);
      }
    }
  }, [timezoneData]);
    const handleRegister = async (e) => {
        e.preventDefault()
        const tzAliases = {
  'Asia/Calcutta': 'Asia/Kolkata',
   'Asia/Bombay': 'Asia/Kolkata',
   'Asia/Colombo': 'Asia/Colombo',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
   // United States
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Alaska': 'America/Anchorage',
  'US/Hawaii': 'Pacific/Honolulu',
  // Canada
  'Canada/Eastern': 'America/Toronto',
  'Canada/Central': 'America/Winnipeg',
  'Canada/Mountain': 'America/Edmonton',
  'Canada/Pacific': 'America/Vancouver',

  // Australia
  'Australia/Sydney': 'Australia/Sydney',
  'Australia/Melbourne': 'Australia/Melbourne',
  'Australia/Brisbane': 'Australia/Brisbane',
  'Australia/Adelaide': 'Australia/Adelaide',
  'Australia/Perth': 'Australia/Perth',
  'Australia/Hobart': 'Australia/Hobart',
  'Australia/Lord_Howe': 'Australia/Lord_Howe',

  // Europe
  'Europe/Belfast': 'Europe/London',
  'Europe/Tel_Aviv': 'Asia/Jerusalem',
  'Europe/Kyiv': 'Europe/Kiev',
  
  'Etc/UTC': 'UTC',
  'Etc/GMT': 'GMT',
  'Etc/GMT+0': 'GMT',
  'Etc/GMT-0': 'GMT',
};
      let timezoneToSubmit=timezone
//  console.log(timezone);
  if (!timezoneToSubmit) {
    // console.log("no");
    
    let deviceTz = localStorage.getItem('device_timezone'); // e.g., "Asia/Kolkata"
    if (deviceTz in tzAliases) {
  deviceTz = tzAliases[deviceTz];
}
   
    
    const matchedTz = timezoneData.data.find(tz => tz.name === deviceTz);
    // console.log(matchedTz);
    
     timezoneToSubmit = matchedTz ? matchedTz.id : '';
     setTimezone(timezoneToSubmit)
  }
// console.log(timezoneToSubmit);

  // Validate fallback timezone value, not the raw state
  if (!timezoneToSubmit) {
    setMessage('Timezone is required.');
    return;
  }

        if (!firstName) {
            setMessage('First name is required.')
            return
        }
        if (!lastName) {
            setMessage('Last name is required.')
            return
        }
        if (!email) {
            setMessage('Email is required.')
            return
        }
        if (!gender) {
            setMessage('Gender is required.')
            return
        }
        if (!dateOfBirth) {
            setMessage('Date of birth is required.')
            return
        }
       

        setMessage('')
       
        
        const formData = new FormData()
        // console.log(formData)
        formData.append('first_name', firstName)
        formData.append('last_name', lastName)
        formData.append('email', email)
        formData.append('gender', gender)
        formData.append('dob', dateOfBirth)
        formData.append('otp_type', 'email')
        formData.append('timezone_id', timezoneToSubmit)
        // const response = await signup(formData)
        for (let pair of formData.entries()) {
            // console.log(`${pair[0]}: ${pair[1]}`)
        }

        // const data = await response.data
        try {
            const response = await signup(formData)
            // console.log('REDDDDDDDDDDDDDDD', response)

            if (response?.data?.code === 'Success') {
                // setMessage(data.message)
                const data = response.data
                localStorage.setItem('email', email)
                localStorage.setItem('OTP_TIMER', OTP_TIMER)
                // For Register Page
                navigate('/otp', { state: { otp_type: 'register' } })
                setTimezone('')
            }
          if (response?.error) {
  const errorData = response?.error?.data;
  const emailError = errorData?.data?.email?.[0]; // first email error if exists
  const message = errorData?.message || "Something went wrong";

  // Combine both
  const finalMessage = emailError ? `${message}: ${emailError}` : message;

  toast.error(finalMessage);
}
        } catch (error) {
            setTimezone('')
            setMessage('Some error occured! Please try again.')
        }
    }

    return (
        // <div className="font-constantia w-1/2 xs:w-full md:w-full sm:w-full flex flex-col justify-center items-center">
        <div className="font-constantia w-[55%] xs:w-full md:w-full sm:w-full flex flex-col  items-center">
              <ToastContainer hideProgressBar />
            {/* <div className="lg:w-9/12 xs:w-11/12 h-[70vh] xs:h-[40vh] sm:h-[50vh] md:h-[45vh]"> */}
            <div className=" xl:w-[90%] xs:w-11/12 h-[70vh] xs:h-[40vh] sm:h-[50vh] md:h-[45vh]">
                <h1 className="text-5xl leading-[55px] xs:leading-[40px] xs:text-3xl md:mb-6 mt-10">
                    <b>SignUp</b>
                </h1>

                <form ref={form} onSubmit={handleRegister}>
                    <h5 className="text-sm mt-8 text-gray-500">Email</h5>
                    <Input
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={'Enter email id'}
                        type="email"
                        className="w-full font-ubuntu placeholder:text-xs placeholder:text-gray-500 rounded-[30px] !p-4 mt-2 xs:mt-4 mb-4 focus:outline-none h-[40px]"
                    />

                    <div className="flex gap-4">
                        <div className="w-1/2">
                            <h5 className="text-sm  text-gray-500">
                                First Name
                            </h5>
                            <Input
                                name="firstName"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder={'Enter First Name'}
                                type="text"
                                className="w-full font-ubuntu placeholder:text-xs placeholder:text-gray-500 rounded-[30px] !p-4 mt-2 xs:mt-4 mb-4 focus:outline-none h-[40px]"
                            />
                        </div>
                        <div className="w-1/2">
                            <h5 className="text-sm  text-gray-500">
                                Last Name
                            </h5>
                            <Input
                                name="lastName"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder={'Enter Last Name'}
                                type="text"
                                className="w-full font-ubuntu placeholder:text-xs placeholder:text-gray-500 rounded-[30px] !p-4 mt-2 xs:mt-4 mb-4 focus:outline-none h-[40px]"
                            />
                        </div>
                    </div>

                    <div className="flex gap-2 items-center ">
                        <div className="flex w-1/2">
                            <div>
                                <h5 className="text-sm  text-gray-500">
                                    Gender
                                </h5>

                                <div
                                    className="flex pb-3  border-b-light border-b-[1px]  justify-evenly
                            "
                                >
                                    <input
                                        type="hidden"
                                        name="gender"
                                        value={gender}
                                        className="!text-xs font-ubuntu w-full"
                                    />
                                    <OptionButton
                                        className={
                                            gender === 'Male'
                                                ? ' bg-orange text-white !text-xs font-ubuntu'
                                                : 'bg-white text-gray-500 !text-xs font-ubuntu'
                                        }
                                        onClick={() => setGender('Male')}
                                    >
                                        Male
                                    </OptionButton>
                                    <OptionButton
                                        className={
                                            gender === 'Female'
                                                ? ' bg-orange text-white !text-xs font-ubuntu'
                                                : 'bg-white text-gray-500 !text-xs font-ubuntu'
                                        }
                                        onClick={() => setGender('Female')}
                                    >
                                        Female
                                    </OptionButton>
                                     <OptionButton
                                        className={
                                            gender === 'Others'
                                                ? ' bg-orange text-white !text-xs font-ubuntu'
                                                : 'bg-white text-gray-500 !text-xs font-ubuntu'
                                        }
                                        onClick={() => setGender('Others')}
                                    >
                                        Other
                                    </OptionButton>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/2 relative">
                            <h5 className="text-sm  text-gray-500">
                                Time Zone
                            </h5>
                            <select
                                name="timezone_id"
                                value={timezone}
                                onChange={(e) => setTimezone(e.target.value)}
                                style={{border: '1px solid #FFDBB0'}}
                                className="w-full appearance-none font-ubuntu placeholder:text-xs text-xs text-gray-700 bg-white rounded-[30px] px-4 py-2 mt-2 mb-4 focus:outline-none h-[42px] "
                            >
                                <option value="">Select Time Zone</option>
                                {timezoneData?.data?.map((tz) => (
                                    <option key={tz.id} value={tz.id}>
                                        {tz.name}
                                    </option>
                                ))}
                            </select>

                            <div className="absolute right-4 bottom-7 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h5 className="text-sm  mb-4 text-gray-500 ">
                            Date of Birth
                        </h5>
                        <div className="">
                            <input
                                type="text"
                                name="dob"
                                className="hidden"
                                value={dateOfBirth}
                                readOnly
                            />
                            <YearPicker
                                defaultValue={'Year'}
                                start={1900}
                                end={new Date().getFullYear()}
                                reverse
                                required={true}
                                value={year}
                                onChange={(e) => setYear(e)}
                                id={'year'}
                                classes={
                                    'p-[.65rem]   mr-2 border-[#FFDBB0] w-[100px] text-center text-xs text-gray-500 border-[1px] rounded-[20px] focus:outline-none font-ubuntu placeholder:text-xs'
                                    
                                }
                                // className=" p-[.65rem]   mr-2 border-[#FFDBB0] w-[100px]  border-[1px] rounded-[20px] text-center text-xs text-gray-300 appearance-none font-ubuntu placeholder:text-xs  bg-white   mt-2 mb-4 focus:outline-none h-[42px] "

                                optionClasses={'option classes'}
                            />
                            <MonthPicker
                                defaultValue={'Month'}
                                endYearGiven // mandatory if end={} is given in YearPicker
                                year={year}
                                required={true}
                                value={month}
                                onChange={(e) => setMonth(e)}
                                id={'month'}
                                classes={
                                    'p-[.65rem] mx-2 border-[#FFDBB0] w-[100px] text-center text-xs text-gray-500 border-[1px] rounded-[20px] focus:outline-none font-ubuntu placeholder:text-xs'
                                }
                                optionClasses={'option classes'}
                            />
                            <DayPicker
                                defaultValue={'Date'}
                                year={year} 
                                month={month} 
                                endYearGiven 
                                required={true}
                                // disabled={!month ? true : false}
                                value={day} 
                                onChange={(e) => setDay(e)}
                                id={'day'}
                                classes={
                                    'p-[.65rem]  mx-2 border-[#FFDBB0] text-xs text-gray-500 w-[100px] text-center border-[1px] rounded-[20px] focus:outline-none font-ubuntu placeholder:text-xs'
                                }
                                optionClasses={'option classes'}
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="bg-[#FFDBB0] mt-6 flex justify-center xs:w-full w-[300px] font-ubuntu items-center text-center h-[40px] rounded-[20px] font-bold text-[#F77F1F]"
                    >
                        Register
                    </button>
                </form>

                {message && <span>{message}</span>}
            </div>
        </div>
    )
}

export default Left
